export default __webpack_public_path__ + "static/media/icon_ui_questionmark.c858b42b.png";